import { render } from "./Marshall.vue?vue&type=template&id=60da7938&scoped=true"
import script from "./Marshall.vue?vue&type=script&lang=js"
export * from "./Marshall.vue?vue&type=script&lang=js"

import "./Marshall.vue?vue&type=style&index=0&id=60da7938&scoped=true&lang=css"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60da7938"]])

export default __exports__